import React from 'react'

import { Icon } from 'src/chrome'
import { CreditCardLogo } from 'src/payments/components'
import { CreditCardBrand } from 'src/payments/components/CardLogo/CreditCardLogo'

import styles from './paymentTab.module.scss'

type PaymentTabProps = {
  paymentType: 'card' | 'points' | 'bank'
  brand?: CreditCardBrand
  last4?: string
}

const PaymentTab: React.FC<PaymentTabProps> = props => {
  const { brand, last4, paymentType } = props
  return (
    <div className={styles.paymentTab}>
      {((): React.ReactElement => {
        switch (paymentType) {
          case 'card':
            return (
              <div className={`${styles.paymentTabContents} ${styles.card}`}>
                <p>{last4 ? `XXXX XXXX XXXX ${last4}` : 'Credit Card'}</p>
                <CreditCardLogo brand={brand} />
              </div>
            )
          case 'points':
            return (
              <div className={styles.paymentTabContents}>
                <Icon
                  icon={'MONEY'}
                  viewBox={'0 0 32 32'}
                  size={28}
                  color={'#F666B0'}
                />
                <p>{`Points & Expense & Credits`}</p>
              </div>
            )
          case 'bank':
            return <div />
        }
      })()}
    </div>
  )
}

export default PaymentTab
